import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getInvoiceDetailsApi } from "../../../api/request/clients/clients";
import columns from "../../../columns/clients/invoice/invoice";
import SkeletonTable from "../../../components/table/SkeletonTable";
import moment from "moment";
import View from "../../../assets/View";
import GlobalTooltip from "../../../components/common/GlobalTooltip";

const Invoice = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const getInvoiceDetails = async () => {
    try {
      setIsLoading(true);
      const { data } = await getInvoiceDetailsApi({
        client_id: id,
        page: currentPage,
      });
      if (data?.status) {
        setData(
          data?.data.map((item) => {
            return {
              ...item,
              created_at: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "--",
              sended_at: item?.invoice_send_date
                ? moment(item?.sended_at).format("lll")
                : "--",
              action: (
                <GlobalTooltip title={"View Invoice"}>
                  <a
                    href={item?.invoice_pdf || "#"}
                    target={item?.invoice_pdf && "_blank"}
                    className="font-medium text-blue-500 w-fit inline-block"
                  >
                    <View />
                  </a>
                </GlobalTooltip>
              ),
            };
          })
        );
        setTotal(data?.total_record);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) getInvoiceDetails();
  }, [currentPage]);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination?.current);
  };

  return (
    <div className="bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <p className=" font-semibold text-2xl">
          Invoices {total ? `(${total})` : null}
        </p>
      </div>

      <div className="mt-5">
        <SkeletonTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default Invoice;
